import avatar1 from "../../../assetes/img/avatar1.svg";
import avatar2 from "../../../assetes/img/avatar2.svg";
import avatar3 from "../../../assetes/img/avatar3.svg";
import avatar4 from "../../../assetes/img/avatar4.svg";
import avatar5 from "../../../assetes/img/avatar5.svg";
import avatar6 from "../../../assetes/img/avatar6.svg";
import avatar7 from "../../../assetes/img/avatar7.svg";
import Linear from "../../../assetes/img/Linear.svg";
export default function Roadmap() {
  return (
    <div className="flex flex-col justify-center items-center text-center">
      <di className="text-[#7E42FF] font-black text-3xl pt-14">
        <span>
          تو این دوره
          <br />
          دقیقا چی یاد میگیری؟
        </span>

        <div className="w-[500px] max-[600px]:w-[370px] max-[400px]:w-[330px] my-20">
          <div className="flex justify-end items-start">
            <div className=" flex flex-col items-center ">
              <img className="w-[100px] max-[600px]:w-[70px] max-[400px]:w-[60px]" src={avatar1} />
              <img className="w-10" src={Linear} />
            </div>
            <div className="w-[200px] max-[600px]:w-[150px] max-[400px]:w-[135px] max-[600px]:px-2  mt-5">
              <span className="text-white font-normal text-[0.5em] max-[600px]:text-[0.4em] leading-tight inline-block">
                ساخت کامل به توکن روی
                <br />
                شبکه ی سولانا
                <br />
                (بدون یه خط کدنویسی)
              </span>
            </div>
          </div>

          <div className="flex justify-start items-start">
          <div className="w-[200px] max-[600px]:w-[150px] max-[600px]:px-2 max-[400px]:w-[135px]  mt-5">
              <span className="text-white font-normal text-[0.5em] leading-tight inline-block">
                لیست کردن توکن روی
                <br />
                DEX Tools
                <br />
                DEX Screener
              </span>
            </div>
            <div className=" flex flex-col items-center ">
              <img className="w-[100px] max-[600px]:w-[70px] max-[400px]:w-[60px]" src={avatar2} />
              <img className="w-10" src={Linear} />
            </div>
          </div>

          <div className="flex justify-end items-start">
            <div className=" flex flex-col items-center ">
              <img className="w-[100px] max-[600px]:w-[70px] max-[400px]:w-[60px]" src={avatar3} />
              <img className="w-10" src={Linear} />
            </div>
            <div className="w-[200px] max-[600px]:w-[150px] max-[600px]:px-2 max-[400px]:w-[135px]  mt-5">
              <span className="text-white font-normal text-[0.5em] leading-tight inline-block">
                راه اندازی پروژه روی ریدیوم
                <br />
                (Raydium)
                <br />و مدیریت لیکوئیدیتی
              </span>
            </div>
          </div>

          <div className="flex justify-start items-start">
          <div className="w-[200px] max-[600px]:w-[150px] max-[600px]:px-2 max-[400px]:w-[135px] mt-5">
              <span className="text-white font-normal text-[0.5em] leading-tight inline-block">
                حفظ امنیت توکن و جلوگیری
                <br />
                از هک و کلاهبرداری
                <br />
              </span>
            </div>
            <div className=" flex flex-col items-center ">
              <img className="w-[100px] max-[600px]:w-[70px] max-[400px]:w-[60px] " src={avatar4} />
              <img className="w-10" src={Linear} />
            </div>
          </div>

          <div className="flex justify-end items-start">
            <div className=" flex flex-col items-center ">
              <img className="w-[100px] max-[600px]:w-[70px] max-[400px]:w-[60px]" src={avatar5} />
              <img className="w-10" src={Linear} />
            </div>
            <div className="w-[200px] max-[600px]:w-[150px] max-[600px]:px-2 max-[400px]:w-[135px] mt-5">
              <span className="text-white font-normal text-[0.5em] leading-tight inline-block">
               اصول مارکتیگ برای رشد و
                <br />
                جذب خریدار واقعی
                <br />
              
              </span>
            </div>
          </div>

          <div className="flex justify-start items-start">
          <div className="w-[200px] max-[600px]:w-[150px] max-[600px]:px-2 max-[400px]:w-[135px] mt-5">
              <span className="text-white font-normal text-[0.5em] leading-tight inline-block">
               ساخت یه جامعه ی فعال و
                <br />
               Community) وفادار دور توکنت 
                <br />
                ( حرفه ای  Building  
              </span>
            </div>
            <div className=" flex flex-col items-center ">
              <img className="w-[100px] max-[600px]:w-[70px] max-[400px]:w-[60px]" src={avatar6} />
              <img className="w-10" src={Linear} />
            </div>
          </div>

          <div className="flex justify-end items-start">
            <div className=" flex flex-col items-center ">
              <img className="w-[100px] max-[600px]:w-[70px]  max-[400px]:w-[60px]" src={avatar7} />
             
            </div>
            <div className="w-[200px] max-[600px]:w-[150px] max-[400px]:w-[135px] max-[600px]:px-2  mt-5">
              <span className="text-white font-normal text-[0.5em] leading-tight inline-block">
              مدیریت عرضه و تفاضا برای
                <br />
                جلوگیری از دامپ شدت قیمت
                <br />
              
              </span>
            </div>
          </div>
        </div>
      </di>
    </div>
  );
}
